/**
 * @flow
 *
 * @format
 */
import { pushEditorAssetAsync, pushReleaseAssetAsync, downloadFileAsync } from './common';
import type { pushEditorAssetType, pushReleaseAssetAsyncType, downloadAssetAsyncType } from './common';

export const pushCityEditorAssetAsync: pushEditorAssetType = async (cityId, filename, file: File, firebase) => {
  const storageFile = firebase.cityEditorStorage(cityId);
  return pushEditorAssetAsync(storageFile, filename, file);
};

export const pushCityReleaseAsset: pushReleaseAssetAsyncType = async (
  cityId,
  version,
  subfolder,
  filename,
  file,
  strContent,
  isPublic,
  firebase,
) => {
  const cityFolder = firebase.cityStorage(cityId);
  return pushReleaseAssetAsync(cityFolder, version, subfolder, filename, file, strContent, isPublic);
};

export const downloadCityAsset: downloadAssetAsyncType = async (cityId, filename, firebase) => {
  console.log('Download editor asset ', cityId, filename);
  const firebaseFile = firebase.cityEditorStorage(cityId).child(filename);
  const url = await firebaseFile.getDownloadURL();
  return downloadFileAsync(url);
};
